import { render, staticRenderFns } from "./RoundUpArticle.vue?vue&type=template&id=f5d6a9cc&scoped=true&"
import script from "./RoundUpArticle.vue?vue&type=script&lang=js&"
export * from "./RoundUpArticle.vue?vue&type=script&lang=js&"
import style0 from "./RoundUpArticle.vue?vue&type=style&index=0&id=f5d6a9cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5d6a9cc",
  null
  
)

export default component.exports